exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-wrapper[data-v-0a528766]{padding:0 24px;height:100%;width:100%;box-sizing:border-box}.scroll-wrapper .file-content[data-v-0a528766]{height:auto;overflow:inherit;padding:0}.scroll-wrapper .properties-title[data-v-0a528766]{height:30px;line-height:30px;border-bottom:1px solid #e8ebef}", ""]);

// exports
